var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeviceOutline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.609,
    height: 20.765,
    viewBox: "0 0 34.609 20.765",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M35.8,7.99a1.73,1.73,0,0,0-1.73,0L27.956,11a5.191,5.191,0,0,0-5.191-5H7.191A5.191,5.191,0,0,0,2,11.191V21.574a5.191,5.191,0,0,0,5.191,5.191H22.765a5.191,5.191,0,0,0,5.191-5l6.16,3.08a1.714,1.714,0,0,0,2.492-1.54V9.461A1.73,1.73,0,0,0,35.8,7.99ZM24.5,21.574a1.73,1.73,0,0,1-1.73,1.73H7.191a1.73,1.73,0,0,1-1.73-1.73V11.191a1.73,1.73,0,0,1,1.73-1.73H22.765a1.73,1.73,0,0,1,1.73,1.73ZM33.148,20.5l-5.191-2.6V14.86l5.191-2.6Z",
    transform: "translate(-2 -6)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceOutline);
export default __webpack_public_path__ + "static/media/device-outline.b2ee6d709acb790a3f6aba52de4084dc.svg";
export { ForwardRef as ReactComponent };